<template>
    <div>
        <Navbar />
        <Banner />
        <Partner />
        <Performance />
        <Transform />
        <Pricing />
        <Choose />
        <Team />
        <Solutions />
        <Graph />
        <Faq />
        <Client />
        <BlogStyleTwo />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import Banner from '../HomeFive/Banner'
import Partner from '../Common/Partner'
import Performance from '../HomeFive/Performance'
import Transform from '../HomeFive/Transform'
import Pricing from '../Common/Pricing'
import Choose from '../HomeFive/Choose'
import Team from '../Common/Team'
import Solutions from '../HomeFive/Solutions'
import Graph from '../HomeFive/Graph'
import Faq from '../HomeFive/Faq'
import Client from '../Common/Client'
import BlogStyleTwo from '../HomeFive/BlogStyleTwo'
import FooterTop from '../Layout/FooterTop'
import FooterBottom from '../Layout/FooterBottom'

export default {
    name: 'HomePageFive',
    components: {
        Navbar,
        Banner,
        Partner,
        Performance,
        Transform,
        Pricing,
        Choose,
        Team,
        Solutions,
        Graph,
        Faq,
        Client,
        BlogStyleTwo,
        FooterTop,
        FooterBottom,
    }
}
</script>